export const RESET_SUMMARY = 'RESET_SUMMARY'
export const RESET_SUMMARY_REASONS = 'RESET_SUMMARY_REASONS'
export const SET_SUMMARY = 'SET_SUMMARY'
export const SET_SUMMARY_REASONS = 'SET_SUMMARY_REASONS'
